import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useMenuLayerContext, useWindowContext } from "../../contexts";
import { joinClasses } from "../../ui/utils/joinClasses";
import startupSettings from "../../util/startupSettings";
/**
 * Provides the main container for the layout, applying necessary classes and refs.
 * For both layouts.
 */
export const LayoutContainer = ({ children, className, }) => {
    const { isFocused, isHidpi } = useWindowContext();
    const { menuLayerOpen, setMenuLayerRef } = useMenuLayerContext();
    const { customTitlebar, useModernLayout } = useSelector((state) => state.settings.window);
    // Add custom titlebar class on mount
    const initializedRef = useRef(false);
    useEffect(() => {
        if (initializedRef.current) {
            return;
        }
        initializedRef.current = true;
        if (customTitlebar) {
            document.body.classList.add("custom-titlebar-body");
        }
    }, [customTitlebar]);
    useEffect(() => {
        document.body.classList.add(`${useModernLayout ? "modern" : "legacy"}-layout`);
    }, []);
    return (React.createElement("div", { className: joinClasses([className], {
            hidpi: isHidpi,
            lodpi: !isHidpi,
            "window-focused": isFocused,
            "window-unfocused": !isFocused,
            "window-frame": customTitlebar,
            "menu-open": menuLayerOpen,
            "no-gpu-acceleration": startupSettings.disableGPU,
        }), key: "main" },
        React.createElement("div", { className: "menu-layer", ref: setMenuLayerRef }),
        children));
};
